import {normalizeDateHeaders} from "../../../../../global/csv_box_helpers";

export interface CustomCoADataItem {
    accountName: string;
    [k: string]: string;
}

export function extractData(values: unknown[]): CustomCoADataItem[] {
    const retVals: CustomCoADataItem[] = [];
    for(const value of values) {
        if(typeof value !== "object" || value === null) {
            continue;
        }

        const row = value as Record<string, unknown>;
        const unmappedData = row["_unmapped_data"] as Record<string, unknown> | undefined;

        if(typeof unmappedData !== "object" || unmappedData === null || unmappedData === undefined) {
            continue;
        }

        const accountName = row["Account Name"];

        if(typeof accountName !== "string") {
            continue;
        }

        const normalizedDateHeaders: Record<string, string> = {};
        for(const [header, value] of Object.entries(unmappedData)) {
            const normalized = normalizeDateHeaders(header);
            if(normalized !== null) {
                normalizedDateHeaders[normalized] = String(value);
            }
        }

        retVals.push({
            accountName: accountName,
            ...normalizedDateHeaders
        });
    }

    return retVals;
}